import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Checkbox, Col, DatePicker, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect } from "react";
import { useFieldArray, useForm, Controller, useFormContext } from "react-hook-form";
import * as yup from "yup";
import dayjs from "dayjs";
import { showNotification } from "service/Notification";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";

const BuilderPayment = ({ ocf, ocfId, getOcfDetails }) => {
  /* ✅ Schema */
  const paymentSchema = yup.object({
    futurePaymentsForm: yup.object({
      payments: yup.array().of(
        yup.object({
          expectedDate: yup.string().required("Expected Date required"),

          percentage: yup
            .number()
            .typeError("Percentage required")
            .required("Percentage required")
            .min(1)
            .max(100),

          billingAllowed: yup.boolean(),

          actualDate: yup.string().nullable(),
        })
      ),

      remark: yup.string().nullable(),
    }),
  });

  /* ✅ useForm */
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(paymentSchema),

    defaultValues: {
      futurePaymentsForm: {
        payments: [],
        remark: "",
      },
    },

    mode: "onSubmit",
  });

  const { watch } = useFormContext();
  const payment = watch("payment");
  const property = watch("property");
  /* ✅ Field Array */
  const { fields } = useFieldArray({
    control,
    name: "futurePaymentsForm.payments",
  });

  //   /* ✅ Load API data */
  //   useEffect(() => {
  //     if (!ocf?.futurePayments) return;

  //     const mapped = ocf.futurePayments.map((item) => ({
  //       expectedDate: item.expectedDate,
  //       percentage: item.percentage,
  //       billingAllowed: item.billingAllowed,
  //       paymentDate: item.paymentDate || "",
  //     }));

  //     setValue("futurePaymentsForm.payments", mapped);
  //   }, [ocf, setValue]);

  const parsePaymentPlan = (plan) => {
    if (!plan) return [];
    if (plan.includes(":")) {
      return plan.split(":").map((p) => Number(p.trim()));
    }
    if (plan === "DP") return [];
    if (plan === "CLP") return [];
    return [];
  };

  useEffect(() => {
    if (!property?.paymentPlan) return;
    // const existingPayments = ocf?.payment ?? [];
    const paymentDetails = ocf?.paymentDetails ?? [];
    setValue("futurePaymentsForm.payments", paymentDetails, {
      shouldValidate: true,
    });
  }, [property, ocf]);

  /* ✅ Submit */
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    const output = {
      ocfId,
      paymentDetails: data.futurePaymentsForm.payments,
      operationRemark: data.futurePaymentsForm.remark,
    };
    axiosPrivate({
      method: "POST",
      url: "om/payment?stage=3",
      data: output,
    })
      .then((response) => {
        showNotification("success", "Success", response?.data?.message);
        navigate(0);
        // /getOcfDetails(ocfId);
      })
      .catch((err) => {
        showNotification("error", "Error", err?.response?.data?.message || "Something went wrong!");
      });
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(onSubmit)(e);
      }}
    >
      <Row gutter={[16, 16]} style={{ margin: "28px 0" }}>
        {fields.map((field, index) => (
          <React.Fragment key={field.id}>
            <Col span={6}>
              <label>Expected Date</label>

              <Controller
                name={`futurePaymentsForm.payments.${index}.expectedDate`}
                control={control}
                render={({ field }) => <Input {...field} disabled />}
              />
            </Col>

            <Col span={6}>
              <label>Payment Date</label>

              <Controller
                name={`futurePaymentsForm.payments.${index}.actualDate`}
                control={control}
                render={({ field }) => (
                  <>
                    <DatePicker
                      style={{ width: "100%" }}
                      format="DD-MM-YYYY"
                      value={field.value ? dayjs(field.value, "DD-MM-YYYY") : null}
                      onChange={(date) => field.onChange(date ? date.format("DD-MM-YYYY") : null)}
                      disabled={!!ocf?.paymentDetails?.[index]?.actualDate}
                    />

                    <p style={{ color: "red", fontSize: 12 }}>
                      {errors?.futurePaymentsForm?.payments?.[index]?.actualDate?.message}
                    </p>
                  </>
                )}
              />
            </Col>

            {/* Percentage */}
            <Col span={4}>
              <label>Builder Payment %</label>

              <Controller
                name={`futurePaymentsForm.payments.${index}.percentage`}
                control={control}
                render={({ field }) => <Input {...field} disabled />}
              />
            </Col>

            {/* Billing */}
            <Col span={4}>
              <Controller
                name={`futurePaymentsForm.payments.${index}.billingAllowed`}
                control={control}
                render={({ field }) => (
                  <Checkbox checked={field.value} disabled>
                    Billing Allowed
                  </Checkbox>
                )}
              />
            </Col>
          </React.Fragment>
        ))}

        {/* Remark */}
        <Col span={12}>
          <label>Remark</label>

          <Controller
            name="futurePaymentsForm.remark"
            control={control}
            render={({ field }) => (
              <>
                <TextArea {...field} rows={3} />

                <p style={{ color: "red", fontSize: 12 }}>
                  {errors?.futurePaymentsForm?.remark?.message}
                </p>
              </>
            )}
          />
        </Col>

        {/* Submit */}
        <Col span={24}>
          <Button type="primary" htmlType="button" onClick={handleSubmit(onSubmit)}>
            Save
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default BuilderPayment;
